var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comments-rate"},[_c('div',{staticClass:"rate-box"},_vm._l((5),function(i){return _c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],key:i,attrs:{"data-src":_vm.getStarSrc(i),"alt":"rate"}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }